import React from 'react';
import PropTypes from 'prop-types';
// import { DeleteFilled, MessageOutlined } from '@ant-design/icons';
// import { Divider } from 'antd';
import { DeleteFilled, MessageOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Divider, Popconfirm, Popover } from 'antd';
// import { QuestionCircleOutlined } from '@ant-design/icons';
// import { Popconfirm } from 'antd';

// import { LinkContainer } from 'react-router-bootstrap';
// // Local Deps
// import { editUserRoute } from '../../../../../config/navigation/routes';
// import trashCan from '../../../../../images/trashcan.svg';
// import edit from '../../../../../images/edit.svg';
// import EmailReset from '../EmailReset';

import './Actions.scss';

export default class Actions extends React.PureComponent {
  static propTypes = {
    cellProps: PropTypes.any.isRequired,
    selectedAction: PropTypes.func,
    activeKey: PropTypes.string.isRequired,
  };

  static defaultProps = {
    selectedAction: (action, id = null, folderName = null) => {
      console.log(action, id, folderName);
    },
  };


  render() {
    const { cellProps, selectedAction, activeKey } = this.props;


    const _delete = () => {
      selectedAction('delete', cellProps.original.id);
    };
    return (
      <span className="actions-wrapper">
        <button
          onClick={() => {
            selectedAction('reply', cellProps.original.id);
          }}
        >
          <MessageOutlined />
        </button>
        <Divider type="vertical" />
        {activeKey[0] !== 'drafts' && activeKey[0] !== 'archived' &&
          <Popover content="Archive">
            <button onClick={_delete}>
              <i className="fa fa-archive" />
            </button>
          </Popover>

        }


        {activeKey[0] === 'drafts' &&
          <Popconfirm
            title="Are you sure? This action cannot be undone."
            icon={
              <QuestionCircleOutlined
                style={{
                  color: 'red',
                }}
              />
            }
            onConfirm={_delete}
          >
            <button>
              <DeleteFilled />
            </button>
          </Popconfirm>
        }

      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/MessageCenterGrid/subComponents/actions/Actions.jsx